import { PLAYLIST_BUTTON_CLASS } from '|>/shared/constants/classes'
import { Events } from '|>/shared/events'
import { on, register } from '|>/shared/vjs'
import { BaseButton } from '../base'

import './playlist-button.css'

/**
 * Playlist button component
 */
@register
export class PlaylistButton extends BaseButton {
  private lastActivationAt_: number = 0
  private lastActivationType_: string | null = null

  @on(Events.Controls.ShowPlaylistControl)
  changeVisibility(visible: Events.Controls.ShowPlayPreviousControl) {
    if (visible) this.show()
    else this.hide()
  }

  override handleClick(event: MouseEvent) {
    const now = Date.now()
    const isSyntheticClickAfterTap =
      event.type === 'click' &&
      this.lastActivationType_ === 'tap' &&
      now - this.lastActivationAt_ < 500

    if (isSyntheticClickAfterTap) {
      event.stopPropagation()
      return
    }

    this.lastActivationAt_ = now
    this.lastActivationType_ = event.type
    event.stopPropagation()
    this.player_.trigger(Events.Player.PlaylistClick)
  }
}

PlaylistButton.options = {
  className: PLAYLIST_BUTTON_CLASS,
}
